import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { reportError } from '../../../lib/error-reporter';
import SetNewPasswordForm from '../../components/set-new-password/form';
import { formatContentWithEmoji } from '../../components/alert';
import {
  setNewUserPassword,
  showAlert,

  ALERT_SET_NEW_PASSWORD_ERROR,
} from '../../actions/index';

const COMPONENT_ID = 'DesktopSetNewPasswordFormContainer';

class SetNewPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(props) {
    const { resetPasswordToken } = this.props;
    return this.props.actions.setNewUserPassword(props, resetPasswordToken)
      .then(() => this.redirect())
      .catch((error) => {
        let errorMessage;
        reportError({
          error,
          component: COMPONENT_ID,
          params: {},
        });
        if (error.is404) {
          errorMessage = <FormattedMessage
            id="setNewPassword.errors.invalidToken"
            defaultMessage="Invalid token, please request your password reset again"
          />;
        } else {
          errorMessage = error.message;
        }
        const content = formatContentWithEmoji(errorMessage, '‼️');
        this.props.actions.showAlert(ALERT_SET_NEW_PASSWORD_ERROR, { content });
      });
  }

  redirect() {
    window.location = this.props.redirectTo;
    return null;
  }

  render() {
    return (
      <SetNewPasswordForm
        email={this.props.email}
        onSubmit={this.onSubmit}
        askFullName={this.props.askFullName}
      />
    );
  }
}

SetNewPasswordContainer.defaultProps = {
  redirectTo: '/login',
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      setNewUserPassword,
      showAlert,
    }, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(SetNewPasswordContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/set-new-password/form.container.js